import { render, staticRenderFns } from "./PlaceHolderLoading.vue?vue&type=template&id=c9507a22&"
import script from "./PlaceHolderLoading.vue?vue&type=script&lang=js&"
export * from "./PlaceHolderLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports